import { LogoProps } from './types';
import Image from 'next/image';

const Logo = ({ image }: LogoProps) => {
  return (
    <Image
      src={image?.url}
      alt={image?.title}
      width={image?.width}
      height={image?.height}
      priority={false}
      className={`m-auto`}
    />
  );
};

export default Logo;
